// @flow
import styled from 'styled-components';

export const ModalOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
	background: rgba(4, 4, 4, 0.72);
`;

export default ModalOverlay;


// WEBPACK FOOTER //
// ./src/components/Modal/ModalOverlay.js